export { default as translations } from './translations.json';

/**
 * Categorize NPS score.
 * @param {number} score — 0-10
 * @returns {'promoter'|'passive'|'detractor'}
 */
export const categorizeScore = (score) => {
  if (score >= 9) return 'promoter';
  if (score >= 7) return 'passive';
  return 'detractor';
};

/**
 * Compute NPS from responses array.
 * @param {Object[]} responses — [{score, comment, userId, submittedAt}]
 * @returns {{ avgScore: number, promoters: number, passives: number, detractors: number, nps: number }}
 */
export const computeNPS = (responses) => {
  if (!Array.isArray(responses) || responses.length === 0) {
    return { avgScore: 0, promoters: 0, passives: 0, detractors: 0, nps: 0 };
  }
  const promoters = responses.filter(r => r.score >= 9).length;
  const detractors = responses.filter(r => r.score <= 6).length;
  const passives = responses.length - promoters - detractors;
  const avg = responses.reduce((s, r) => s + r.score, 0) / responses.length;
  const nps = Math.round(((promoters - detractors) / responses.length) * 100);
  return { avgScore: Math.round(avg * 10) / 10, promoters, passives, detractors, nps };
};

/**
 * Validate NPS score.
 * @param {*} score
 * @returns {string|null}
 */
export const validateScore = (score) => {
  if (!Number.isInteger(score) || score < 0 || score > 10) return 'Score must be integer 0-10';
  return null;
};
